var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UserLayout',{attrs:{"showNavBar":true,"pageTitle":"Personalizza azienda"},scopedSlots:_vm._u([{key:"page-content",fn:function(props){return [_c('v-card',{staticClass:"form-card",attrs:{"outlined":""}},[_c('FrmSettings')],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }